import React from 'react'
import {
  TableRow as MuiTableRow,
  TableRowProps as MuiTableRowProps,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import palette from '../Themes/palette'

const TableRowContainer = styled(MuiTableRow, {
  shouldForwardProp: (prop) => prop !== 'isClickable',
})<TableRowProps>(({ isClickable }) => ({
  cursor: isClickable ? 'pointer' : 'default',
  '&:hover': {
    backgroundColor: isClickable ? palette.secondary.purple50 : 'inherit',
  },
}))

export interface TableRowProps extends MuiTableRowProps {
  children: React.ReactNode
  isClickable?: boolean
  onClick?: () => void
}

const TableRow = (props: TableRowProps) => {
  const { children, isClickable = false, onClick, ...rest } = props
  return (
    <TableRowContainer onClick={onClick} isClickable={isClickable} {...rest}>
      {children}
    </TableRowContainer>
  )
}

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  TableRow.displayName = 'TableRow'
}

export default React.memo(TableRow)
